import { useState, useEffect } from "react";
import TwoDigitInput from "../../components/TwoDigitInput/TwoDigitInput";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const RepRangeInput = (props) => {
  const [currentRepRange, setCurrentRepRange] = useState({
    min: props.minInitialValue,
    max: props.maxInitialValue,
  });
  const isLoading = props.isLoading;

  useEffect(() => {
    setCurrentRepRange({
      min: props.minInitialValue,
      max: props.maxInitialValue,
    });
  }, [props.minInitialValue, props.maxInitialValue]);

  const handleRepRangeMinSubmit = (newMinReps) => {
    props.onSubmit({ min: newMinReps, max: currentRepRange.max });
  };

  const handleRepRangeMaxSubmit = (newMaxReps) => {
    props.onSubmit({ min: currentRepRange.min, max: newMaxReps });
  };

  return (
    <div>
      <h2 className="block text-sm font-medium text-gray-700">Rep Range</h2>
      <div className="flex flex-row gap-x-4 items-center">
        <TwoDigitInput
          id="rep-range-min"
          initialValue={currentRepRange.min || ""}
          className="w-[calc((100vw-16px-16px-14px-16px-20px)/3)]"
          onBlur={handleRepRangeMinSubmit}
          isLoading={isLoading}
        />
        <span className="block text-sm text-gray-700">to</span>
        <TwoDigitInput
          id="rep-range-max"
          initialValue={currentRepRange.max || ""}
          className="w-[calc((100vw-16px-16px-14px-16px-20px)/3)]"
          onBlur={handleRepRangeMaxSubmit}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default RepRangeInput;
